"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AuthoringWorksheet {
    constructor(_authoringWorksheetImpl) {
        this._authoringWorksheetImpl = _authoringWorksheetImpl;
    }
    getAbstractQueryWithDataModelAsync() {
        return this._authoringWorksheetImpl.getAbstractQueryWithDataModel();
    }
    getVizStateWithDataModelAsync() {
        return this._authoringWorksheetImpl.getVizStateWithDataModel();
    }
    setVizStateWithDataModelAsync(vizStateWithDataModel) {
        return this._authoringWorksheetImpl.setVizStateWithDataModel(vizStateWithDataModel);
    }
}
exports.AuthoringWorksheet = AuthoringWorksheet;
//# sourceMappingURL=AuthoringWorksheet.js.map